import { createSlice } from '@reduxjs/toolkit'

export const widthSlice = createSlice({
  name: 'windowWidth',
  initialState: {
    value: window.innerWidth
  },
  reducers: {
    update: (state, action) => {
      state.value = action.payload;
    }
  }
})

export const { update } = widthSlice.actions

export const selectWindowWidth = (state) => state.windowWidth.value

export default widthSlice.reducer